module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-modern-6-22c35488773784e330a2a17f95d383b9.webp";